const CustomIcon = ({name}) => {
    return <div data-testid={`${name}_button`} className={`d-icon-${name}`} />
}

export default CustomIcon
